export const educationData = [
    {
        id: 1,
        institution: 'Kabi Nazrul Govt. College',
        course: 'Higher Secondary School Certificate',
        startYear: '2019',
        endYear: '2021'
    },
    {
        id: 2,
        institution: 'National University, Dhaka, Bangladesh',
        course: 'BSc in CSE',
        startYear: '2021',
        endYear: 'Present'
    }
]